import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, EMPTY_STRING } from '../../../../constants/common'
import { Divider } from '../../../Divider'
import { PROFILE_INFO_NOTES_FIELD_NAME } from '../ProfileInfoWidget.constants'
import { ProfileInfoWidgetFormField } from '../ProfileInfoWidgetFormField'
import { ProfileInfoWidgetNotesField } from '../ProfileInfoWidgetNotesField'

import * as styles from './ProfileInfoWidgetRows.module.css'

function ProfileInfoWidgetRows({
  NotesField = ProfileInfoWidgetNotesField,
  config = EMPTY_LIST,
  options,
}) {
  const { t } = useTranslation()

  const rows = [
    ...(NotesField
      ? [{ key: PROFILE_INFO_NOTES_FIELD_NAME, node: <NotesField /> }]
      : EMPTY_LIST),
    ...config.map(field => ({
      key: field.name,
      node: (
        <ProfileInfoWidgetFormField
          field={{
            ...field,
            label: t(field.labelKey),
            placeholder: field.placeholderKey
              ? t(field.placeholderKey)
              : EMPTY_STRING,
          }}
          options={options}
        />
      ),
    })),
  ]

  return rows.map(({ key, node }, index) => (
    <Fragment key={key}>
      {index > 0 ? <Divider className={styles.divider} /> : null}
      {node}
    </Fragment>
  ))
}

export default ProfileInfoWidgetRows
